<script lang="ts" setup></script>

<template>
    <input type="hidden" name="_token" value="" />
</template>

<style scoped></style>
